var createRelationalOperation=require("./_createRelationalOperation"),gte=createRelationalOperation(function(e,t){return t<=e});module.exports=gte;